import { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { useListLanguages, useUpdateLanguageStatus } from "../../../hooks/useLanguages"
import { useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';

export default function LanguageSettings() {
  const [languages, setLanguages] = useState([]);
  const { data: languagesListResponse, isSuccess: isSuccessLanguagesList } = useListLanguages('')
  const updateStatusMutation = useUpdateLanguageStatus()
  const queryClient = useQueryClient();

  const toggleStatus = (id, currentStatus) => {
    updateStatusMutation.mutate({
      status: currentStatus == 1 ? 3 : 1,
      language_id: id
    }, {
      onSuccess: () => {
        toast.success("Language status updated.")
        queryClient.invalidateQueries({ queryKey: ['languages'] });
      },
      onError: (error) => {
        const message = error.response?.data?.message
        toast.error(message)
      }
    })
  };

  useEffect(() => {
    if (isSuccessLanguagesList) {
      setLanguages(languagesListResponse?.data?.data?.result)
    }
  }, [languagesListResponse, isSuccessLanguagesList])

  return (
    <div className="flex h-screen bg-white text-gray-800">
      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Breadcrumb */}
        <div className="border-b border-gray-200 p-4 flex items-center gap-2 text-sm">
          <span className="text-gray-500">Dashboard</span>
          <ChevronRight size={14} className="text-gray-400" />
          <span className="text-gray-500">Settings</span>
          <ChevronRight size={14} className="text-gray-400" />
          <span>Languages</span>
        </div>
        {/* Content */}
        <div className="p-6 flex-1">
          <div className="mb-6">
            <h1 className="text-2xl font-semibold mb-2">Languages</h1>
            <p className="text-gray-500">Manage languages that you want your users to use on the app</p>
          </div>
          {/* Table */}
          <div className="border border-gray-200 rounded overflow-hidden mb-4">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 bg-gray-50">
                  <th className="px-4 py-3 text-left">Languages</th>
                  <th className="px-4 py-3 text-left">Short Code</th>
                  <th className="px-4 py-3 text-left">Status</th>
                </tr>
              </thead>
              <tbody>
                {languages.map(language => (
                  <tr key={language.id} className="border-b border-gray-200">
                    <td className="px-4 py-3">{`${language?.image} ${language?.name}`}</td>
                    <td className="px-4 py-3">{language?.short_code}</td>
                    <td className="px-4 py-3">
                      <button
                        onClick={() => toggleStatus(language?._id, language?.status)}
                        className="focus:outline-none">
                        <div className={`w-12 h-6 rounded-full flex items-center ${language?.status == 1 ? 'bg-gray-900' : 'bg-gray-300'} p-1 transition-colors duration-200`}>
                          <div className={`w-4 h-4 rounded-full bg-white transform transition-transform duration-200 ${language.status == 1 ? 'translate-x-6' : 'translate-x-0'}`}></div>
                        </div>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}